<template>
  <div
    class="resultStatus resultAccepted full-width full-height flex column justify-center text-center q-px-lg"
    :class="{
      scheduledPickup:
        detail && detail.scheduled && detail.serviceType === 'PICK_UP',
    }"
  >
    <div v-if="isSuccessDELIVERY">
      <div class="title font-size-20 text-weight-bolder statuscode-box">
        <div>
          <strong v-html="orderMsgs.status" />
        </div>
        <div>
          <strong> {{ orderMsgs.Driver }}</strong>
        </div>
        <div>
          <strong> {{ orderMsgs.Seller }}</strong>
        </div>
      </div>
      <div class="YourMeal-box">
        <div class="desc font-size-16 text-theme-gray q-my-sm statuscode-value">
          <span> {{ orderMsgs.value }}</span>
        </div>
        <div
          v-if="[900].includes(shipmentStatusCode)"
          class="desc font-size-16 text-theme-gray q-my-sm CourierInfo"
        >
          <span> {{ orderMsgs.CourierInfo }}</span>
        </div>
        <div
          v-if="isRiderToBuyer"
          class="desc font-size-16 text-theme-gray q-my-sm CourierInfo"
        >
          <span> {{ orderMsgs.CourierInfo }}</span>
        </div>
        <div
          v-if="isRiderToBuyer"
          class="desc text-theme-gray q-my-sm GKNumber"
        >
          <span> {{ shipmentExternalId }}</span>
        </div>
      </div>

      <div class="CheckDetails">
        <span @click="alterCheck">{{ $t('result.showDetilStatus1') }}</span>
        <!-- <q-img
          src="~assets/icons/svg/icon/ChevronRight.svg"
          style="width: 16px;height: 20px;"
        /> -->
        <span class="iconfont">&#xe744;</span>
      </div>
    </div>
    <div v-if="serviceTypeStatus !== 'DELIVERY'">
      <div class="title font-size-20 text-weight-bolder">
        {{ $t('result.preparing') }}
      </div>
      <div class="desc font-size-16 text-theme-gray q-my-sm q-mt-md">
        {{ $t('result.preparingMsg') }}
      </div>
      <div class="font-size-16 text-weight-bolder q-mt-md">
        {{
          isApartDine
            ? STORE_TABLE
            : detail.serviceType === 'DINE_IN'
            ? `${$t('checkout.Number', [STORE_TABLE])}`
            : $t('result.collarNumber')
        }}
      </div>
      <div
        class="number text-weight-bolder font-size-60 q-mt-md"
        :class="{ 'apart-area-address': isApartDine }"
      >
        {{ mealCode }}
      </div>
    </div>
    <SchedPick
      v-if="detail && detail.scheduled && detail.serviceType === 'PICK_UP'"
      :start-time="scheduledStartDate"
      :end-time="scheduledEndDate"
    />
    <Popup :service-type="serviceTypeStatus" @setPopupChild="setPopupChild" />
  </div>
</template>

<script>
import orderMixins from 'pages/mixin/orderMixins.js';
import Popup from './Popup.vue';
import { formatDate } from '../../utils/base';
import SchedPick from './components/SchedPick.vue';

export default {
  components: {
    Popup,
    SchedPick,
  },
  mixins: [orderMixins],
  props: {
    mealCode: {
      type: String,
      default: '',
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showTypeInit: false,
      serviceTypeStatus: '',
      shipmentStatusCode: '',
      paymentMethodType: '',
      shipmentExternalId: '',
      scheduledStartDate: '',
      scheduledEndDate: '',
    };
  },
  computed: {
    STORE_TABLE() {
      return this.$t(`list.table${this.storeInfo.businessType}`);
    },
    isDine() {
      return this.detail.serviceType === 'DINE_IN';
    },
    isApartDine() {
      return this.isApartment && this.isDine;
    },
  },
  watch: {
    detail: {
      handler(val) {
        val = val || {};
        this.serviceTypeStatus = val.serviceType;
        if (val.scheduledEndDate) {
          this.scheduledStartDate = formatDate(
            val.scheduledDate?.dbStamp,
            'EEE, dd MMMM, HH:mm',
          );
          this.scheduledEndDate = formatDate(
            val.scheduledEndDate?.dbStamp,
            'HH:mm',
          );
        }
        if (val.shipment) {
          this.shipmentStatusCode = val.shipment.trackingStatusCode;
          this.paymentMethodType = val.payments[0].paymentMethodType;
          this.shipmentExternalId = val.shipment.externalId;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 历史记录 插入当前界面
      window.history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    setPopupChild(child) {
      this.popupChild = child;
    },
    alterCheck() {
      if (this.popupChild) {
        this.popupChild.alert = true;
      }
    },
    getStatus(code) {
      code = +code;
      //  * 等待支付
      // WAITING_TO_PAID(200),
      if (code >= 200 && code < 300) {
        return 200;
      }
      //  * 付款成功
      // PAID(300),
      if (code >= 300 && code < 400) {
        return 300;
      }
      //  * 商家已接单
      // ACCEPTED(400),
      if (code >= 400 && code < 500) {
        return 400;
      }
      //  * 商家备餐中
      // PREPARING(500),
      if (code >= 500 && code < 600) {
        return 500;
      }
      //* 等待骑手到店取货
      // READY(600)
      if (code >= 600 && code < 610) {
        return 600;
      }
      // Searching for Courier 寻找棋手
      if (code >= 610 && code < 620) {
        return 610;
      }
      //   Driver Assigned  找到棋手
      if (code >= 620 && code < 630) {
        return 620;
      }
      /// / On the Way Pick Up  棋手正在来的路上
      if (code >= 630 && code < 700) {
        return 630;
      }
      //  * 骑手到店已取货
      // PICKED_UP(700),
      if (code >= 700 && code < 800) {
        return 700;
      }
      //  * 配送中
      // DELIVERING(800)  //Delivering to customer  棋手正在 送货
      if (code >= 800 && code < 900) {
        return 800;
      }
      //  * 已送达
      // DELIVERED(900),       // Delivered   交付完成
      if (code >= 900 && code < 1000) {
        return 900;
      }
      if (code >= 1000 && code <= 1030) {
        return 610;
      }
      /// // 订单失败状态
      if (code > 1030 && code < 1040) {
        return 1040;
      }
      return '';
    },
    goBack() {
      window.history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style lang="scss" scoped>
.resultAccepted {
  background: url('~src/assets/images/result/acceptedBg.png') no-repeat center;
  background-size: cover;
  .title {
    color: #0ea5e9;
    line-height: 120%;
  }
  .desc {
    line-height: 16px;
  }
  .number {
    line-height: 100%;
  }
}
.scheduledPickup {
  padding-bottom: 46px !important;
}
////
.YourMeal {
  color: #6b7280;
  font-weight: normal;
}
.Thank-courier > div {
  color: #6b7280;
  font-weight: normal;
}
.CheckDetails {
  margin-top: 10px;
  font-weight: bold;
  color: $primary;
  font-size: 12px;
  .iconfont {
    vertical-align: middle;
  }
}

.statuscode-box {
  color: #ff9e2d;
}
.statuscode-value {
  color: #6b7280;
}

.CourierInfo {
  color: $black;
}
.GKNumber {
  font-size: 36px;
  color: $black;
  font-weight: bold;
}
.scheduled {
  background: #f3f4f6;
}
</style>
